import { Location } from 'history';

import { Customer, UserInfo } from '../../services/auth';

export interface SessionStateInterface {
  customer?: Customer;
  token: string;
  loading: boolean;
  error?: any;
  redirectTo?: Location;
  userInfo?: UserInfo;
}

export default class SessionState implements SessionStateInterface {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    public customer?: Customer,
    public token = '',
    public loading = false,
    public error?: any,
    public redirectTo?: Location,
    public userInfo?: UserInfo
  ) {}
}
